import React, { useState } from 'react';
import { ChevronsLeftRightIcon } from 'lucide-react';
interface BeforeAfterSliderProps {
  before: string;
  after: string;
  beforeAlt: string;
  afterAlt: string;
  className?: string;
}
export function BeforeAfterSlider({
  before,
  after,
  beforeAlt,
  afterAlt,
  className = ''
}: BeforeAfterSliderProps) {
  const [pos, setPos] = useState(50);
  return <div className={`relative select-none overflow-hidden rounded-2xl bg-navy-900 ${className}`} data-id="element-17" data-mp="3d1q4l6xv1stx">
      <img src={after} alt={afterAlt} className="absolute inset-0 h-full w-full object-cover" draggable={false} data-id="element-18" data-mp="382lwkjmoa156" />
      <div className="absolute inset-0" style={{
      clipPath: `inset(0 ${100 - pos}% 0 0)`
    }} data-id="element-19" data-mp="3m24qo8infbyh">
        <img src={before} alt={beforeAlt} className="absolute inset-0 h-full w-full object-cover" draggable={false} data-id="element-20" data-mp="3i12p3l19entc" />
      </div>

      <span className="pointer-events-none absolute left-4 top-4 rounded-lg bg-navy-900/80 px-3 py-1.5 text-sm font-semibold text-white" data-id="element-21" data-mp="1rpexjt03u6s5">
        Before
      </span>
      <span className="pointer-events-none absolute right-4 top-4 rounded-lg bg-white px-3 py-1.5 text-sm font-semibold text-navy" data-id="element-22" data-mp="18lumq3i47c9f">
        After
      </span>

      <div className="pointer-events-none absolute inset-y-0 w-0.5 -translate-x-1/2 bg-white" style={{
      left: `${pos}%`
    }} aria-hidden="true" data-id="element-23" data-mp="1dl7b4somwre4">
        <span className="absolute left-1/2 top-1/2 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-navy shadow-lg" data-id="element-24" data-mp="1nah4scz4mi4c">
          <ChevronsLeftRightIcon className="h-5 w-5" data-id="element-25" data-mp="1sbws6bos10pw" />
        </span>
      </div>

      <input type="range" min={0} max={100} value={pos} onChange={e => setPos(Number(e.target.value))} aria-label="Drag to compare before and after renovation" className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0" data-id="element-26" data-mp="1w9m0zcn7tzdc" />
    </div>;
}